"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionsDetails = void 0;
exports.RegionsDetails = [
    {
        continentCode: 'NA',
        countryCode: 'US',
        coordinates: [-78.6568942, 37.4315734],
        description: 'This region is recommended to serve users in the eastern United States',
        displayName: 'Virginia',
        endPoint: 'https://e8bcfmapzh.execute-api.us-east-1.amazonaws.com/prod/region',
        name: 'us-east-1',
        availabilityZones: [
            { zoneName: 'us-east-1a', state: 'available' },
            { zoneName: 'us-east-1b', state: 'available' },
            { zoneName: 'us-east-1c', state: 'available' },
            { zoneName: 'us-east-1d', state: 'available' },
            { zoneName: 'us-east-1e', state: 'available' },
            { zoneName: 'us-east-1f', state: 'available' },
        ],
    },
    {
        continentCode: 'NA',
        countryCode: 'US',
        coordinates: [-82.907123, 40.417287],
        description: 'This region is recommended to serve users in the eastern United States',
        displayName: 'Ohio',
        endPoint: 'https://9k640y1xvi.execute-api.us-east-2.amazonaws.com/prod/region',
        name: 'us-east-2',
        availabilityZones: [
            { zoneName: 'us-east-2a', state: 'available' },
            { zoneName: 'us-east-2b', state: 'available' },
            { zoneName: 'us-east-2c', state: 'available' },
        ],
    },
    {
        continentCode: 'NA',
        countryCode: 'US',
        coordinates: [-120.554201, 43.804133],
        description: 'This region is recommended to serve users in the northwestern United States, Alaska, and western Canada',
        displayName: 'Oregon',
        endPoint: 'https://r52mcryphe.execute-api.us-west-2.amazonaws.com/prod/region',
        name: 'us-west-2',
        availabilityZones: [
            { zoneName: 'us-west-2a', state: 'available' },
            { zoneName: 'us-west-2b', state: 'available' },
            { zoneName: 'us-west-2c', state: 'available' },
            { zoneName: 'us-west-2d', state: 'available' },
        ],
    },
    {
        continentCode: 'EU',
        countryCode: 'IE',
        coordinates: [-8.24389, 53.41291],
        description: 'This region is recommended to serve users in Ireland, the United Kingdom, and Iceland',
        displayName: 'Ireland',
        endPoint: 'https://n70jvpb5da.execute-api.eu-west-1.amazonaws.com/prod/region',
        name: 'eu-west-1',
        availabilityZones: [
            { zoneName: 'eu-west-1a', state: 'available' },
            { zoneName: 'eu-west-1b', state: 'available' },
            { zoneName: 'eu-west-1c', state: 'available' },
        ],
    },
    {
        continentCode: 'EU',
        countryCode: 'GB',
        coordinates: [-0.127758, 51.507351],
        description: 'This region is recommended to serve users in Ireland, the United Kingdom, and Iceland',
        displayName: 'London',
        endPoint: 'https://g9b6ohg9lc.execute-api.eu-west-2.amazonaws.com/prod/region',
        name: 'eu-west-2',
        availabilityZones: [
            { zoneName: 'eu-west-2a', state: 'available' },
            { zoneName: 'eu-west-2b', state: 'available' },
            { zoneName: 'eu-west-2c', state: 'available' },
        ],
    },
    {
        continentCode: 'EU',
        countryCode: 'FR',
        coordinates: [2.352222, 48.856614],
        description: 'This region is recommended to serve users in France and central Europe',
        displayName: 'Paris',
        endPoint: 'https://2md5h0jffh.execute-api.eu-west-3.amazonaws.com/prod/region',
        name: 'eu-west-3',
        availabilityZones: [
            { zoneName: 'eu-west-3a', state: 'available' },
            { zoneName: 'eu-west-3b', state: 'available' },
            { zoneName: 'eu-west-3c', state: 'available' },
        ],
    },
    {
        continentCode: 'EU',
        countryCode: 'DE',
        coordinates: [8.682127, 50.110922],
        description: 'This region is recommended to serve users in Europe, the Middle East, and Africa',
        displayName: 'Frankfurt',
        endPoint: 'https://sedctg0mdd.execute-api.eu-central-1.amazonaws.com/prod/region',
        name: 'eu-central-1',
        availabilityZones: [
            { zoneName: 'eu-central-1a', state: 'available' },
            { zoneName: 'eu-central-1b', state: 'available' },
            { zoneName: 'eu-central-1c', state: 'available' },
        ],
    },
    {
        continentCode: 'AP',
        countryCode: 'SG',
        coordinates: [103.819836, 1.352083],
        description: 'This region is recommended to serve users in India and Southeast Asia',
        displayName: 'Singapore',
        endPoint: 'https://ajfk8ars1j.execute-api.ap-southeast-1.amazonaws.com/prod/region',
        name: 'ap-southeast-1',
        availabilityZones: [
            { zoneName: 'ap-southeast-1a', state: 'available' },
            { zoneName: 'ap-southeast-1b', state: 'available' },
            { zoneName: 'ap-southeast-1c', state: 'available' },
        ],
    },
    {
        continentCode: 'AP',
        countryCode: 'AU',
        coordinates: [151.20699, -33.867487],
        description: 'This region is recommended to serve users in Austalia, New Zealand, and the South Pacific',
        displayName: 'Sydney',
        endPoint: 'https://39tv3d1sdd.execute-api.ap-southeast-2.amazonaws.com/prod/region',
        name: 'ap-southeast-2',
        availabilityZones: [
            { zoneName: 'ap-southeast-2a', state: 'available' },
            { zoneName: 'ap-southeast-2b', state: 'available' },
            { zoneName: 'ap-southeast-2c', state: 'available' },
        ],
    },
    {
        continentCode: 'AP',
        countryCode: 'JP',
        coordinates: [139.769017, 35.6804],
        description: 'This region is recommended to serve users in Japan',
        displayName: 'Tokyo',
        endPoint: 'https://gm08qe9heb.execute-api.ap-northeast-1.amazonaws.com/prod/region',
        name: 'ap-northeast-1',
        availabilityZones: [
            { zoneName: 'ap-northeast-1a', state: 'available' },
            { zoneName: 'ap-northeast-1b', state: 'available' },
            { zoneName: 'ap-northeast-1c', state: 'available' },
        ],
    },
    {
        continentCode: 'AP',
        countryCode: 'KR',
        coordinates: [126.977969, 37.566535],
        description: 'This region is recommended to serve users in South Korea',
        displayName: 'Seoul',
        endPoint: 'https://ev44h6w7h4.execute-api.ap-northeast-2.amazonaws.com/prod/region',
        name: 'ap-northeast-2',
        availabilityZones: [
            { zoneName: 'ap-northeast-2a', state: 'available' },
            { zoneName: 'ap-northeast-2b', state: 'available' },
            { zoneName: 'ap-northeast-2c', state: 'available' },
        ],
    },
    {
        continentCode: 'AP',
        countryCode: 'IN',
        coordinates: [72.877656, 19.075984],
        description: 'This region is recommended to serve users in India and southern Asia',
        displayName: 'Mumbai',
        endPoint: 'https://if5i1tr8rd.execute-api.ap-south-1.amazonaws.com/prod/region',
        name: 'ap-south-1',
        availabilityZones: [
            { zoneName: 'ap-south-1a', state: 'available' },
            { zoneName: 'ap-south-1b', state: 'available' },
            { zoneName: 'ap-south-1c', state: 'available' },
        ],
    },
    {
        continentCode: 'NA',
        countryCode: 'CA',
        coordinates: [-73.567256, 45.501689],
        description: 'This region is recommended to serve users in eastern and central Canada',
        displayName: 'Montreal',
        endPoint: 'https://0ofqthc36m.execute-api.ca-central-1.amazonaws.com/prod/region',
        name: 'ca-central-1',
        availabilityZones: [
            { zoneName: 'ca-central-1a', state: 'available' },
            { zoneName: 'ca-central-1b', state: 'available' },
        ],
    },
];
//# sourceMappingURL=allRegions.js.map